import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNetwork } from '../contexts/NetworkContext';
import { useWallet } from '../contexts/WalletContext';
import { useEscrow } from '../contexts/EscrowContext';
import Header from './Header';
import DepositForm from './DepositForm';
import './DepositPage.css';

const DepositPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentNetwork } = useNetwork();
  const { provider, signer, account, isConnected, onAccountChange } = useWallet();
  const { isAddressSet, contractAddress } = useEscrow();

  // Navigate to homepage if not connected or no escrow address
  useEffect(() => {
    if (!isConnected || !isAddressSet) {
      navigate('/');
      return;
    }
  }, [isConnected, isAddressSet, navigate]);

  // Listen for account changes and redirect to homepage
  useEffect(() => {
    const unsubscribe = onAccountChange((newAccount) => {
      // Redirect to homepage when account changes
      navigate('/');
    });
    
    return unsubscribe;
  }, [onAccountChange, navigate]);

  const onDepositSuccess = async () => {
    // Could add a success notification here
  };

  return (
    <div className="deposit-page">
      <Header subtitle="Make a Deposit" />
      
      <main className="container">
        <div className="main-content">
            
            {currentNetwork ? (
              <DepositForm 
                signer={signer!} 
                network={currentNetwork}
                userAddress={account}
                provider={provider!}
                contractAddress={contractAddress!}
                onDeposit={onDepositSuccess}
              />
            ) : (
              <div className="no-network">
                <h3>No Network Selected</h3>
                <p>Please select a supported network to continue.</p>
              </div>
            )}
            
        </div>
      </main>
      
      <footer>
        <p>Contact us: <a href="mailto:contact@trustline.id">contact@trustline.id</a></p>
      </footer>
    </div>
  );
};

export default DepositPage;
